import React from 'react'
import { useTranslation } from 'react-i18next'
import about from '../images/about.webp'
export default function AboutUs() {
  const { t } = useTranslation();
  return (
    <div className='container'>
      <div className='about'>
        <div className='text-area'>
            <h1>{t('about.title')}</h1>
            <p>{t('about.p1')}</p>
            <p>{t('about.p2')}</p>
            <p>{t('about.p3')}</p>
            <p>{t('about.p4')}</p>
            <p>{t('about.p5')}</p>
            <p>{t('about.p6')}</p>
        </div>
        <img src={about} alt='none image'/>
      </div>
    </div>
  )
}
